module.exports = __webpack_public_path__ + "img/wellness-video-bg.2e0e6680.png";